interface PaginatedResponse<T> {
    '@context': string;
    '@id': string;
    '@type': string;
    'hydra:member': T[];
    'hydra:totalItems': null | number;
    'hydra:view': {
        '@id': null | string;
        '@type': null | string;
        'hydra:first': null | string;
        'hydra:last': null | string;
        'hydra:next': null | string;
    };
}

function getID(field?: null | string) {
    if (!field) return null;
    const popped = field.split('=').pop();
    if (!popped) return null;
    const val = parseInt(popped);
    return Number.isNaN(val) ? null : val;
}

function getQueryStringValue(string: null | string, key: string) {
    if (!string) return null;
    const keyVals = string.split('?')[1].split('&');
    const val = keyVals.find((keyVal) => keyVal.split('=')[0] === key);
    if (typeof val === 'undefined') {
        return null;
    }
    return val.split('=')[1];
}

export function convertPagination<T>(data: PaginatedResponse<T>): PaginationType {
    const itemsPerPage = getQueryStringValue(data['hydra:view']['@id'], 'items_per_page');
    const perPage = itemsPerPage === null ? null : parseInt(itemsPerPage);
    return {
        current: getID(data['hydra:view']['@id']),
        first: getID(data['hydra:view']['hydra:first']),
        next: getID(data['hydra:view']['hydra:next']),
        last: getID(data['hydra:view']['hydra:last']),
        total: data['hydra:totalItems'] || null,
        items_per_page: Number.isNaN(perPage) ? null : perPage,
    };
}

export interface PaginationType {
    current: null | number;
    first: null | number;
    next: null | number;
    last: null | number;
    total: null | number;
    // eslint-disable-next-line babel/camelcase
    items_per_page: null | number;
}
export function emptyPagination(): PaginationType {
    return {
        current: 1,
        first: 1,
        next: null,
        last: 1,
        total: null,
        items_per_page: 25,
    };
}
